import Home from "./Home";
import Covid from "./Covid";
import SystemFAQ from "./SystemFAQ";
import NewCust from "./NewCust";
import PaymentOpts from "./PaymentOpts";
import PaymentAsst from "./PaymentAsst";
import Forms from "./Forms";
import FAQ from "./FAQ";
import Contact from "./Contact";
import FCRA from "./FairCredit";
import ESign from "./ESign";
import ESignContent from "./ESignContent";
import EDeliver1098 from "./1098EDeliver";
import RecurACH from "./RecurACH";
import OneTimeACH from "./OneTimeACH";
import ServiceTransfer from "./ServiceTransfer";
import Disclosure1098 from "./1098EDeliver"; 

export default {
   Home,
   Covid,
   SystemFAQ,
   NewCust,
   PaymentOpts,
   PaymentAsst,
   Forms,
   FAQ,
   Contact,
   FCRA,
   ESign,
   ESignContent,
   EDeliver1098,
   RecurACH,
   OneTimeACH,
   ServiceTransfer,
   Disclosure1098
}
